import styled from 'styled-components';

import { Title } from '@components/blocks/blocks.styles';
import { media } from '@theme/media';
import { COLORS } from '@theme/colors';
import { FONT_SIZE, typography } from '@theme/font';
import { OFFSET } from '@theme/helpers';

export const EditorialTitle = styled(Title)`
  margin-top: 0;
`;

export const List = styled.ul`
  padding: 0;
  margin: 0;

  p {
    margin: 0;
  }
`;

export const Container = styled.div`
  padding: 0 ${OFFSET.S} ${OFFSET.L} ${OFFSET.S};
  position: relative;
  width: 100%;

  ${media.bigDesktop} {
    max-width: 1440px;
    margin: 0 auto;
  }

  ${media.tablet} {
    padding: 0 ${OFFSET.M} ${OFFSET.L} ${OFFSET.M};
  }
`;

interface FullWidthContainerProps {
  bgURL: string;
}

export const FullWidthContainer = styled.div<FullWidthContainerProps>`
  width: 100%;
  height: 60vh;
  position: relative;
  margin-top: -15px;
  top: 0;
  background: ${(props) => `url(${props.bgURL}) no-repeat top center`};
  background-size: cover;
  display: flex;
  justify-content: center;

  ${media.desktop} {
    height: 90vh;
  }
`;

export const Description = styled.div`
  position: absolute;
  bottom: ${OFFSET.M};
  margin: 0 auto;
  ${typography({})};
  text-align: center;
  padding-bottom: ${OFFSET.M};
  border-bottom: 3px solid ${COLORS.WHITE};
  color: ${COLORS.WHITE};
  width: 90vw;
  display: flex;
  flex-direction: column;
  text-transform: full-size-kana;

  ${media.desktop} {
    width: 576px;
    ${typography({ size: FONT_SIZE.M })};
  }
`;
